<script lang="ts">
  import { nvrs, selectedNvr, visibleStreams } from '../lib/stores';

  type Props = {
    fullscreen?: boolean;
    fullscreenLabel?: string;
    onback?: () => void;
  };
  let { fullscreen = false, fullscreenLabel = '', onback }: Props = $props();

  const title = $derived.by(() => {
    if (fullscreen && fullscreenLabel) return fullscreenLabel;
    if ($selectedNvr) {
      const n = $nvrs.find((x) => x.id === $selectedNvr);
      return n?.name ?? $selectedNvr;
    }
    return 'Все камеры';
  });

  function toggleMobile(): void {
    document.body.classList.toggle('sidebar-open');
  }
</script>

<header>
  <button class="menu-toggle" onclick={toggleMobile} aria-label="меню">
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor"
         stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </svg>
  </button>
  {#if fullscreen}
    <button class="back" onclick={onback}>‹ Назад</button>
  {/if}
  <h1>{title}</h1>
  <span class="spacer"></span>
  <span class="stat">{$visibleStreams.length} cam{$visibleStreams.length === 1 ? '' : 's'}</span>
</header>

<style>
  header {
    grid-area: header;
    display: flex; align-items: center; gap: 16px;
    padding: 0 20px;
    background: var(--bg-elev);
    backdrop-filter: blur(20px) saturate(180%);
    -webkit-backdrop-filter: blur(20px) saturate(180%);
    border-bottom: 1px solid var(--border);
    z-index: 10;
  }
  h1 { font-size: 15px; font-weight: 600; letter-spacing: -.01em; margin: 0; }
  .spacer { flex: 1; }
  .stat { font-size: 12px; color: var(--fg-muted); font-variant-numeric: tabular-nums; }
  .back {
    padding: 4px 10px; border-radius: 6px;
    color: var(--accent); font-size: 13px; font-weight: 500;
  }
  .menu-toggle {
    display: none;
    width: 28px; height: 28px;
    place-items: center; border-radius: 6px;
    color: var(--fg-muted);
  }
  .menu-toggle:hover { color: var(--fg); background: rgba(127,127,127,.08); }
  @media (max-width: 700px) { .menu-toggle { display: inline-grid; } }
</style>
